import { create } from "zustand";

const useUserRoleStore = create((set) => ({
  role: localStorage.getItem("role"),
  setRole: (newRole) => set({ role: newRole }),
}));

export default useUserRoleStore;
